/* eslint-disable jsx-a11y/anchor-is-valid */
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import {
  Row,
  Col,
  Alert,
  message,
  Form,
  Input,
  Button,
  Checkbox,
} from 'antd';
import React, { useState } from 'react';
import Logo from '../../components/Logo2';

import styles from './index.module.scss';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

const LoginMessage: React.FC<{
  content: string;
}> = ({ content }) => (
  <Alert
    style={{
      marginBottom: 24,
    }}
    message={content}
    type="error"
    showIcon
  />
);

const Login: React.FC = (props: any) => {
  const navigate = useNavigate();
  const [type, setType] = useState<string>('account');
  const [loading, setLoading] = useState<boolean>(false);

  const fetchUserInfo = async ({ user, token }: any) => {
    if (user._id) {
      localStorage.setItem('token', token);
      localStorage.setItem('DataFixTime', 'true');
      axios.interceptors.request.use(function (config: any) {
        config.headers.Authorization = `Bearer ${token}`;

        return config;
      });
    }
  };

  const login = async (values: any) => {
    const { data } = await axios.post('/auth/login', values);
    return data;
  };

  const handleSubmit = async (values: any) => {
    try {
      const { user, token } = await login(values);

      if (user._id) {
        let path = '/';
        const { permission } = user;
        message.success('เข้าสู่ระบบสำเร็จ!');
        await fetchUserInfo({ user, token });

        props.dispatch({
          type: 'UPDATE_USER',
          data: user,
        });

        setTimeout(() => {
          window.location.href = path;
        }, 1000);
      }
    } catch (error: any) {
      if (error?.response?.data?.error?.code === 'invalid-password') {
        message.warning('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง!');
      } else {
        message.error('เข้าสู่ระบบผิดพลาด โปรดลองใหม่อีกครั้ง!');
      }

      setLoading(false);
    }
  };

  const onFinish = async (values: any) => {
    setLoading(true);
    await handleSubmit(values);
  };

  const onRegister = () => {
    const path = '/register';
    navigate(path);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Row
          justify="center"
          align="middle"
          style={{ height: '100%' }}
        >
          <Col span={24} style={{ maxWidth: 300 }}>
            <div className={styles.headerWrapper}>
              <Logo />
            </div>
            <Form
              name="normal_login"
              className="login-form"
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="username"
                className="mb-5"
                label="ชื่อผู้ใช้"
                rules={[
                  { required: true, message: 'กรุณาป้อนชื่อผู้ใช้!' },
                ]}
              >
                <Input
                  prefix={
                    <UserOutlined className="site-form-item-icon" />
                  }
                  placeholder="Username"
                />
              </Form.Item>
              <Form.Item
                name="password"
                className="mb-5"
                label="รหัสผ่าน"
                rules={[
                  { required: true, message: 'กรุณาป้อนรหัสผ่าน!' },
                ]}
              >
                <Input
                  prefix={
                    <LockOutlined className="site-form-item-icon" />
                  }
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>
              <div className={styles.subLoginContent}>
                <Form.Item className="mb-5">
                  <Form.Item
                    name="remember"
                    valuePropName="checked"
                    noStyle
                  >
                    <Checkbox>จดจำฉัน</Checkbox>
                  </Form.Item>
                </Form.Item>
              </div>

              <Form.Item className="text-center">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={loading}
                >
                  เข้าสู่ระบบ
                </Button>
              </Form.Item>
              <div className={styles.registerWrapper}>
                <span>ยังไม่มีบัญชีผู้ใช้?</span>
                <a
                  onClick={onRegister}
                  className={styles.linkToRegis}
                >
                  สมัครสมาชิก
                </a>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(Login);
